<template>
  <!-- https://tracker.globetrack.ie/issues/11519 - Admin > AI Setup (GT support
       only, same menu rule as Tenant Setup). Setup = per-tenant module settings,
       Usage = spend dashboard (#11520, AIS-07). #11522: one content width and
       padding for the title, the tab bar and both tabs. -->
  <v-container fluid class="ai-setup pa-4 pa-md-6">
    <div class="mb-4">
      <h1 class="headline">AI Setup</h1>
      <div class="body-2 grey--text" :class="mutedShade">
        Per-tenant AI module settings, monthly caps and usage.
      </div>
    </div>

    <v-tabs v-model="tab" background-color="transparent" class="ai-setup-tabs">
      <v-tab>
        <v-icon small left>mdi-tune</v-icon>
        Setup
      </v-tab>
      <v-tab>
        <v-icon small left>mdi-chart-bar</v-icon>
        Usage
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="transparent">
      <v-tab-item>
        <ai-setup-setup-tab></ai-setup-setup-tab>
      </v-tab-item>
      <v-tab-item>
        <ai-setup-usage-tab></ai-setup-usage-tab>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import AiSetupSetupTab from "./AiSetupSetupTab";
import AiSetupUsageTab from "./AiSetupUsageTab";

export default {
  name: "ai-setup",

  components: { AiSetupSetupTab, AiSetupUsageTab },

  data() {
    return {
      tab: 0,
    };
  },

  computed: {
    mutedShade() {
      return this.$vuetify.theme.dark ? "text--lighten-1" : "text--darken-1";
    },
  },
};
</script>

<style scoped>
.ai-setup {
  max-width: 1440px;
}
.ai-setup-tabs {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.theme--dark .ai-setup-tabs,
.ai-setup-tabs.theme--dark {
  border-bottom-color: rgba(255, 255, 255, 0.12);
}
.ai-setup-tabs >>> .v-tab {
  letter-spacing: 0.06em;
}
</style>

<!-- Shared by the two tabs and the module card; every rule is under .ai-setup. -->
<style>
.ai-setup .ai-card {
  border-radius: 10px !important;
}
.ai-setup .ai-card.theme--light.v-card--outlined {
  border-color: rgba(0, 0, 0, 0.1);
}
.ai-setup .tabular {
  font-variant-numeric: tabular-nums;
}
.ai-setup .ai-overline {
  font-size: 0.6875rem;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
/* Hints and errors line up with the field's left edge and the label above it,
   instead of being indented by the outlined field's inner padding. */
.ai-setup .ai-flush .v-text-field__details {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.ai-setup .ai-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/ai-setup/AiSetup.vue